import { useState } from "react";
import { ArrowRight, LockKeyhole } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";
import { useBrand } from "@/context/BrandContext";
import { apiError } from "@/lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const { brand } = useBrand();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "visor_plano" ? "/visor-plano" : "/");
    } catch (requestError) {
      setError(apiError(requestError));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-page" data-testid="login-page">
      <section
        aria-label="Puerto Santa Cruz"
        className="login-image"
        style={{ "--login-image": `url("${brand.login_image_url}")` }}
      >
        <div className="login-image-overlay" />
        <div className="login-brand" data-testid="login-brand">
          <img
            alt="Puerto Santa Cruz Yacht Club Resort"
            className="login-logo"
            data-testid="login-brand-logo"
            src={brand.logo_url}
          />
          <p>YACHT CLUB RESORT</p>
          <h1>Decisiones claras.<br />Ventas mejor guiadas.</h1>
        </div>
      </section>
      <section className="login-form-area">
        <form className="login-form" data-testid="login-form" onSubmit={submit}>
          <span className="eyebrow">ACCESO COMERCIAL</span>
          <h2>Bienvenido de vuelta</h2>
          <p>Ingresa para consultar lotes y preparar cotizaciones.</p>
          <label htmlFor="email">Correo</label>
          <input
            data-testid="login-email-input"
            id="email"
            onChange={(event) => setEmail(event.target.value)}
            type="email"
            value={email}
          />
          <label htmlFor="password">Contraseña</label>
          <input
            data-testid="login-password-input"
            id="password"
            onChange={(event) => setPassword(event.target.value)}
            type="password"
            value={password}
          />
          {error && <p className="form-error" data-testid="login-error-message">{error}</p>}
          <button
            className="primary-button"
            data-testid="login-submit-button"
            disabled={submitting}
            type="submit"
          >
            <LockKeyhole size={17} />
            {submitting ? "Ingresando..." : "Ingresar"}
            <ArrowRight size={17} />
          </button>
        </form>
      </section>
    </main>
  );
}